import { render, staticRenderFns } from "./SelectHorarioStep.vue?vue&type=template&id=a8065688&scoped=true&"
import script from "./SelectHorarioStep.vue?vue&type=script&lang=js&"
export * from "./SelectHorarioStep.vue?vue&type=script&lang=js&"
import style0 from "./SelectHorarioStep.vue?vue&type=style&index=0&id=a8065688&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8065688",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle})
